import { Box, Image, Stack } from "@mantine/core";
import type { JSX } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import classes from "./ImageThreadsPage.module.css";

interface IterationNode {
    id: number;
    file: { src: string } | null;
}

interface Props {
    id: number;
    latestImageIteration: IterationNode | null;
}

export default function ImageThreadCard({ id, latestImageIteration }: Props): JSX.Element {
    const { search } = useLocation();

    return (
        <Link to={`/image-threads/${id}${search}`} className={classes.link}>
            <Stack>
                {latestImageIteration?.file?.src && (
                    <Image src={latestImageIteration.file.src} height={200} fit="contain" radius="sm" />
                )}
                <Box>Thread #{id}</Box>
            </Stack>
        </Link>
    );
}
